import { combineReducers } from 'redux'
import {
  BIAYAPENGURUSAN_GET_LOADING,
  BIAYAPENGURUSAN_GET_ERROR,
  BIAYAPENGURUSAN_GET_SUCCESS,

  BIAYAPENGURUSAN_VIEW_ERROR,
  BIAYAPENGURUSAN_VIEW_LOADING,
  BIAYAPENGURUSAN_VIEW_SUCCESS,

  BIAYAPENGURUSAN_ADD_ERROR,
  BIAYAPENGURUSAN_ADD_LOADING,
  BIAYAPENGURUSAN_ADD_SUCCESS,

  BIAYAPENGURUSAN_DELETE_ERROR,
  BIAYAPENGURUSAN_DELETE_LOADING,
  BIAYAPENGURUSAN_DELETE_SUCCESS
} from '../actions/constant'

const biayapengurusanGetError = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_GET_ERROR:
      return action.biayapengurusanGetError
    default:
      return state
  }
}

const biayapengurusanGetLoading = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_GET_LOADING:
      return action.biayapengurusanGetLoading
    default:
      return state
  }
}

const biayapengurusanGetSuccess = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_GET_SUCCESS:
      return action.biayapengurusanGetSuccess
    default:
      return state
  }
}

const biayapengurusans = (state = [], action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_GET_SUCCESS:
      return action.biayapengurusans
    default:
      return state
  }
}

const biayapengurusanViewLoading = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_VIEW_LOADING:
      return action.biayapengurusanViewLoading
    default:
      return state
  }
}

const biayapengurusanViewError = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_VIEW_ERROR:
      return action.biayapengurusanViewError
    default:
      return state
  }
}

const biayapengurusanViewSuccess = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_VIEW_SUCCESS:
      return action.biayapengurusanViewSuccess
    default:
      return state
  }
}

const biayapengurusan = (state=[], action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_VIEW_SUCCESS:
      return action.biayapengurusan
    case BIAYAPENGURUSAN_ADD_SUCCESS:
      return action.biayapengurusan
    default:
      return state
  }
}

const biayapengurusanAddError = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_ADD_ERROR:
      return action.biayapengurusanAddError
    default:
      return state
  }
}

const biayapengurusanAddLoading = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_ADD_LOADING:
      return action.biayapengurusanAddLoading
    default:
      return state
  }
}

const biayapengurusanAddSuccess = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_ADD_SUCCESS:
      return action.biayapengurusanAddSuccess
    default:
      return state
  }
}

const biayapengurusanDeleteError = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_DELETE_ERROR:
      return action.biayapengurusanDeleteError
    default:
      return state
  }
}

const biayapengurusanDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_DELETE_LOADING:
      return action.biayapengurusanDeleteLoading
    default:
      return state
  }
}

const biayapengurusanDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case BIAYAPENGURUSAN_DELETE_SUCCESS:
      return action.biayapengurusanDeleteSuccess
    default:
      return state
  }
}

const biayapengurusanReducer = combineReducers({
  biayapengurusanGetError,
  biayapengurusanGetLoading,
  biayapengurusanGetSuccess,
  biayapengurusans,

  biayapengurusanViewLoading,
  biayapengurusanViewError,
  biayapengurusanViewSuccess,
  biayapengurusan,

  biayapengurusanAddError,
  biayapengurusanAddLoading,
  biayapengurusanAddSuccess,

  biayapengurusanDeleteError,
  biayapengurusanDeleteLoading,
  biayapengurusanDeleteSuccess
})

export default biayapengurusanReducer
